// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"10ceab5c","239":"9b8ea382","453":"05cbbdee","667":"d0c414ae"}[chunkId] + ".chunk.js";
};